import axiosInstance from "../Middleware/interceptor";
import { toast } from "react-toastify";

export const postApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.post(`${url}`, data, config);
    // Don't show toast here - let the component handle success/error messages
    // if (response?.data?.statusCode === 200) {
    //   toast.success(response?.data?.message);
    // } else {
    //   toast.error(response?.data?.message);
    // }

    return response?.data;
  } catch (error) {
    // Don't show toast for errors - let the component handle it
    // This allows components to show custom error messages
    
    // if (error.response) {
    //   toast.error(`Error: ${error.response.data.message || 'An unexpected error occurred'}`);
    // } else if (error.request) {
    //   toast.error('No response from server. Please try again later.');
    // } else {
    //   toast.error(`Error: ${error.message}`);
    // }

    throw error; // Re-throw the error to propagate it further if necessary
  }
};

export const getApi = async (url, config = {}) => {
  try {
    const response = await axiosInstance.get(`${url}`, config);
    // Don't show toast here - let the component handle success/error messages
    // if(response?.data?.statusCode === 200){
    //   // toast.success(response?.data?.message)
    // } else{
    //   toast.error(response?.data?.message)
    // }
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const downloadApi = async (url, fallbackFilename = 'download', config = {}) => {
  const response = await axiosInstance.get(url, {
    ...config,
    responseType: 'blob',
  });

  const disposition = response.headers['content-disposition'] || '';
  const filenameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
  const filename = filenameMatch
    ? filenameMatch[1].replace(/['"]/g, '')
    : fallbackFilename;

  const blob = new Blob([response.data], {
    type:
      response.headers['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
};

export const putApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.put(`${url}`, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const patchApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.patch(`${url}`, data, config);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteApi = async (url, data, config = {}) => {
  try {
    // For DELETE requests with body, axios requires data in config object
    const response = await axiosInstance.delete(`${url}`, {
      ...config,
      data: data
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};
